import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Dialog, DialogContent } from "@mui/material";
import fetchWithAuth from "../../../util/fetchWithAuth";
import { API_URL } from "../../../util/url";

const ComboDays = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const [comboData, setComboData] = useState({
    currentDays: 0,
    prizes: [],
    combo_days: 0,
  });

  useEffect(() => {
    let active = true;

    const loadCombo = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchWithAuth(
          `${API_URL}/user/combo-widget/`
        );

        if (response.status === 404) {
          if (!active) return;
          setComboData({
            currentDays: 0,
            prizes: [],
            combo_days: 0,
          });
          return;
        }

        if (!response.ok) {
          throw new Error("Помилка запиту");
        }

        const json = await response.json();
        const sortedPrizes = [...(json.all || [])].sort(
          (a, b) => a.days_required - b.days_required
        );

        if (!active) return;
        setComboData({
          currentDays: json.combo_days || 0,
          prizes: sortedPrizes,
          combo_days: json.combo_days || 0,
        });
      } catch (err) {
        if (!active) return;
        setError(err);
      } finally {
        if (active) setLoading(false);
      }
    };

    loadCombo();

    return () => {
      active = false;
    };
  }, []);

  const getProgressWidth = () => {
    if (!comboData.prizes || comboData.prizes.length === 0) return "0%";
    const maxDays = comboData.prizes[comboData.prizes.length - 1].days_required;
    return `${Math.min((comboData.currentDays / maxDays) * 100, 100)}%`;
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  const { currentDays, prizes, combo_days } = comboData;

  return (
    <>
      <Card
        sx={{
          color: "#fff",
          boxShadow: "none",
          borderRadius: 3,
          p: 3,
          minHeight: 80,
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(true)}
      >
        <Box sx={{ mr: 2 }}>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.0939 36.6666C43.4639 31.6666 32.0573 11.6666 18.2056 3.33325C16.5756 9.16659 14.1306 10.8333 9.24227 16.6666C2.76894 24.3899 5.98394 33.3333 14.9456 36.6666C13.5873 34.9999 10.0839 31.4999 12.5006 26.6666C13.3339 24.9999 15.0006 23.3333 14.1673 19.9999C15.7973 20.8333 19.1673 21.6666 20.0006 25.8333C21.3589 24.1666 22.7673 20.6666 21.4639 16.6666C31.6673 24.1666 27.5006 31.6666 23.0939 36.6666Z"
              stroke="#4CAF50"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Box>
        <Box>
          <Typography
            style={{
              color: "#8695AA",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "21px",
              letterSpacing: 0,
            }}
          >
            Комбо-дні
          </Typography>
          <h1 style={{ fontWeight: 700, fontSize: "20px" }}>
            {combo_days} дні поспіль
          </h1>
        </Box>
      </Card>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            background: "none",
            boxShadow: "none",
            backdropFilter: "none",
            borderRadius: 0,
            p: 0,
          },
        }}
      >
        <DialogContent
          sx={{
            background: "#fff",
            color: "#fff",
            borderRadius: 2,
            p: 0,
            minWidth: 700,
            boxShadow: "none",
            overflow: "visible",
            position: "relative",
            ".dark-theme &": {
              background: "#0C1427",
              color: "#fff",
            },
          }}
        >
          <Box sx={{ position: "absolute", top: 12, right: 20, zIndex: 10 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 32,
                fontWeight: 300,
              }}
              onClick={() => setOpen(false)}
              className="text-black"
            >
              &times;
            </span>
          </Box>

          <Box sx={{ p: 2, width: "100%" }}>
            <Typography
              sx={{
                fontWeight: 500,
                mb: 3,
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
              className="text-black"
            >
              <span style={{ fontSize: 22, marginRight: 10 }}>ⓘ</span>Натисніть
              на приз щоб обрати
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 3, mb: 3 }}>
              {prizes.map((prize, i) => (
                <Box
                  key={prize.id}
                  onClick={() => setActive(i)}
                  sx={{
                    flex: 1,
                    background: active === i ? "#605DFF33" : "transparent",
                    border: "2px solid #605DFF",
                    borderRadius: 4,
                    p: 3,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    minWidth: 0,
                    minHeight: 110,
                    transition: "all 0.2s",
                    boxShadow: "none",
                    position: "relative",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: 27,
                        mr: 1,
                      }}
                      className="text-black"
                    >
                      {prize.days_required}
                      <span
                        style={{
                          fontSize: 16,
                          width: "54px",
                          marginLeft: "20px",
                          overflowWrap: "break-word",
                          whiteSpace: "normal",
                          alignSelf: "center",
                          alignItems: "center",
                          display: "inline-block",
                        }}
                        className="text-black"
                      >
                        Комбо днів
                      </span>
                    </Typography>
                    <Box
                      sx={{
                        ml: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#605DFF",
                        marginLeft: "70px",
                        p: 1,
                        borderRadius: 2,
                        ".dark-theme &": {
                          background: "#172036",
                        },
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 16,
                          color: "#fff",
                        }}
                      >
                        {prize.prize_description}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>

            <Box
              sx={{
                background: "#232B3E",
                borderRadius: 2,
                height: 28,
                mb: 1,
                width: "100%",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  background: "#6C63FF",
                  borderRadius: 2,
                  height: "100%",
                  width: getProgressWidth(),
                  transition: "width 0.3s",
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#fff",
                fontWeight: 500,
                fontSize: 16,
                mt: 0.5,
              }}
            >
              {prizes.map((prize) => (
                <Typography
                  key={prize.id}
                  className="text-black"
                  sx={{ fontWeight: 400 }}
                >
                  {prize.days_required} днів
                </Typography>
              ))}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ComboDays;
